import { getUnlocalizedLocations } from './locationMappers'
import type { GetLocationsOptions, Iso3166Location } from './types'

export default function getLocationsFromIntl({
  unlocalizedLocations = getUnlocalizedLocations(),
  language: fsLanguageCode,
}: GetLocationsOptions): Iso3166Location[] {
  try {
    const locale = mapToIntlLocale(fsLanguageCode)
    if (
      typeof Intl === 'undefined' ||
      typeof Intl.DisplayNames === 'undefined' ||
      typeof Intl.Collator === 'undefined' ||
      Intl.DisplayNames.supportedLocalesOf(locale).length === 0
    ) {
      return null
    }
    const displayNames = new Intl.DisplayNames(locale, { type: 'region' })
    const collator = new Intl.Collator(locale)
    return unlocalizedLocations
      .map(({ alpha2, alpha3 }) => ({
        alpha2,
        alpha3,
        text: displayNames.of(alpha2),
      }))
      .sort((a, b) => collator.compare(a.text, b.text))
  } catch (error) {
    console.error(error)
  }
  return null
}

function mapToIntlLocale(fsLanguageCode): string {
  // See https://github.com/unicode-org/cldr/tree/main/common/main
  switch (fsLanguageCode) {
    case 'zh':
      return 'zh-hant'
    default:
      return fsLanguageCode
  }
}
